import React from "react";
import { Clapperboard, Film, Users, Star, TrendingUp } from "lucide-react";

const CastingKpiGrid = ({ dashboardData }) => {
  const kpis = [
    {
      title: "Total Projects",
      value: dashboardData?.kpis?.totalProjects || 0,
      icon: <Clapperboard size={18} />,
      trend: "+2 this month"
    },
    {
      title: "Active Roles",
      value: dashboardData?.kpis?.activeRoles || 0,
      icon: <Film size={18} />,
      trend: "Active"
    },
    {
      title: "Total Applicants",
      value: dashboardData?.kpis?.totalApplicants || 0,
      icon: <Users size={18} />,
      trend: "+15%"
    },
    {
      title: "Shortlisted",
      value: dashboardData?.kpis?.shortlisted || 0,
      icon: <Star size={18} />,
      trend: "Selected"
    }
  ];

  return (
    <div className="cdd-kpi-grid">
      {kpis.map((kpi, index) => (
        <div className="cdd-kpi-card" key={index}>
          <div className="cdd-kpi-top">
            <div className="cdd-kpi-icon">{kpi.icon}</div>
            <div className="cdd-kpi-trend">
              <TrendingUp size={12} /> <span>{kpi.trend}</span>
            </div>
          </div>
          <h3 className="cdd-kpi-value">{kpi.value}</h3>
          <p className="cdd-kpi-label">{kpi.title}</p>
        </div>
      ))}
    </div>
  );
};

export default CastingKpiGrid;
